export const VESTING_PAYMENTS_WIDGET_ID = 'vesting'
